/* global require, console, window, document */
import * as Sentry from "@sentry/browser";
import axios from "axios";
import Echo from "laravel-echo";
import Pusher from "pusher-js";

export default () => {
  /**
   * Initialize Echo
   */
  window.Pusher = Pusher;
  window.Echo = new Echo({
    broadcaster: "pusher",
    key: window.Castos?.config?.pusher?.key ?? "",
    cluster: window.Castos?.config?.pusher?.cluster ?? "eu",
    forceTLS: true,
  });

  /**
   * Initialize Sentry if it has been defined.
   */
  if (
    window.Castos?.config?.sentry &&
    typeof window.Castos.config.sentry.dsn === "string"
  ) {
    if (window.Castos.config.sentry.enableReplay) {
      Sentry.init({
        dsn: window.Castos.config.sentry.dsn,
        integrations: [
          Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
            maskAllInputs: false,
            minReplayDuration: 2500,
            mask: [
              "#apiToken",
              "#payment-element",
              'input[name="password"]',
              'input[name="password_confirmation"]',
              "[data-sensitive-input]",
            ],
          }),
        ],
        environment: window.Castos.config.sentry.environment ?? "local",
        replaysSessionSampleRate:
          typeof parseFloat(window.Castos.config.sentry.replaySampleRate) ===
          "number"
            ? parseFloat(window.Castos.config.sentry.replaySampleRate)
            : 0.1,
        replaysOnErrorSampleRate:
          typeof parseFloat(
            window.Castos.config.sentry.replayErrorSampleRate
          ) === "number"
            ? parseFloat(window.Castos.config.sentry.replayErrorSampleRate)
            : 1,
      });
      window.Sentry = Sentry;
      // Stop session on logout
      document.addEventListener("click", async function (event) {
        if (event.target.dataset.logoutLink) {
          const replay = Sentry.getReplay();
          if (replay) {
            try {
              await replay.flush();
              await replay.stop();
            } catch (err) {
              console.error(err);
            }
          }
        }
      });
    } else {
      Sentry.init({
        dsn: window.Castos.config.sentry.dsn,
        environment: window.Castos.config.sentry.environment ?? "local",
      });
    }

    Sentry.setUser({
      id: window.Castos.config.userId ?? null,
      email: window.Castos.config.userEmail ?? null,
    });
  }

  /**
   * Set up axios and make globally available.
   */
  window.axios = axios;
  window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
  const token = document.head.querySelector('meta[name="csrf-token"]');
  const api_token = window.Castos.config.userApiKey ?? "";

  if (token) {
    window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
    window.axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${api_token}`;
  } else {
    console.error(
      "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
    );
  }

  try {
    window.Popper = require("popper.js").default;
    window.$ = window.jQuery = require("jquery");

    require("bootstrap");
  } catch (e) {
    console.error(e);
  }
};
